import type { ReactNode } from "react";
import { Box, Paper, Stack, Text, Title } from "@mantine/core";
import { BrandMark } from "../../components/icons";
import styles from "./auth.module.css";

/*
 * The auth hero (2026-07-21 polish pass) — login / change-password live on a
 * near-black instrument-panel backdrop with the launch-trajectory arc; the
 * light card floats on top. Structure (Title order 1, labelled inputs) is
 * unchanged so the auth test-suite queries keep matching.
 */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className={styles.hero}>
      {/* The trajectory arc, drawn on load (decorative). */}
      <svg className={styles.arc} viewBox="0 0 1440 400" preserveAspectRatio="none" aria-hidden>
        <defs>
          {/* The arc climbs THROUGH the spectrum — cyan liftoff to indigo apex. */}
          <linearGradient id="auth-arc-grad" x1="0" y1="400" x2="1440" y2="0" gradientUnits="userSpaceOnUse">
            <stop stopColor="rgba(34, 184, 207, 0.55)" />
            <stop offset="0.5" stopColor="rgba(139, 92, 246, 0.55)" />
            <stop offset="1" stopColor="rgba(120, 125, 245, 0.6)" />
          </linearGradient>
        </defs>
        <path
          className={styles.arcPath}
          d="M-40 390 C 420 350, 980 190, 1480 -40"
          stroke="url(#auth-arc-grad)"
          strokeWidth="1.5"
          fill="none"
        />
      </svg>

      <div className={styles.column}>
        <div className={styles.lockup}>
          <BrandMark size={26} />
          <span className={styles.lockupName}>
            Meta <span>launcher</span>
          </span>
        </div>

        <Paper className={styles.card} shadow="xl" radius="lg" p="xl">
          <Stack gap="lg">
            <Stack gap={4}>
              <Title order={1} fz="h2">
                {title}
              </Title>
              {subtitle && (
                <Text c="dimmed" fz="sm">
                  {subtitle}
                </Text>
              )}
            </Stack>
            {children}
          </Stack>
        </Paper>

        {footer && (
          <Box ta="center" fz="sm" c="#8d94a8">
            {footer}
          </Box>
        )}

        <div className={styles.footer}>Malaberg · internal launch console</div>
      </div>
    </div>
  );
}
